
import css from '../../css/toolbox.module.css';
import { Vector3 } from 'three';
import { toolBoxManagerTemplate } from './toolBoxManagerTemplate';

export class ToolBox2DManager extends toolBoxManagerTemplate {
	constructor( modules, managers ) {
		super( modules, managers);
		this.managers.ToolBox2DManager = this;
	}

	async init() {
		
		//add css
		this._addStyle( 'toolboxStyle', css );

		document.querySelector( '#toolbox' ).innerHTML = '';
		this.modules.toolbox.init( { containerId: 'toolbox', buttonList: this.#getButtonList() } );

		// disable delete cells button
		this.enableControl( 'deleteCells', false );

		// move row and column buttons
		this.moveRowColumnButtons();
	}
	
	#getButtonList() {
		return this.#getUtilityButtonList().
			concat( this.#getRowColumnButtons() ).
			concat( this.#get2Dto3DButton() );
	}

	#getUtilityButtonList() {
		return [
			{
				title: 'select cells',
				containerId: 'utility2DContainer',
				name: 'selectCells',
				icon: 'checklist_rtl',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					await this.trigger( 'onSelectButtonPushed' );
					this.enable( targets.t, targets.c );
				}
			},
			{
				title: 'delete cells',
				containerId: 'utility2DContainer',
				name: 'deleteCells',
				icon: 'delete',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					await this.trigger( 'onDeleteCells' );
					this.enable( targets.t, targets.c );
				}
			}
		];
	}

	#getRowColumnButtons() {
		return [
			{
				title: 'Añadir Fila',
				containerId: 'rowBContainer',
				name: 'addRow',
				icon: 'exposure_plus_1',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					//TODO: show modal to select row length
					await this.trigger( 'onAddRow', 3 );
					this.enable( targets.t, targets.c );
				}
			},
			{
				title: 'Añadir Columna',
				containerId: 'columnBContainer',
				name: 'addColumn',
				icon: 'exposure_plus_1',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					// TODO: show modal to select column width
					await this.trigger( 'onAddColumn', 6.4 );
					this.enable( targets.t, targets.c );
				}
			}
		];
	}

	#get2Dto3DButton() {
		return [
			{
				title: 'GoToInit',
				containerId: 'drawContainer',
				name: 'GoToInit',
				icon: 'arrow_back',
				label: '',
				callback: async e => {
					//disable button while trigering event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					await this.trigger( 'from2DtoInit' );
					this.enable( targets.t, targets.c );
				}
			},
			{
				title: 'GoTo3D',
				containerId: 'drawContainer',
				name: 'GoTo3D',
				icon: 'arrow_forward',
				label: '',
				callback: async e => {
					//disable button while trigering event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					await this.trigger( 'from2Dto3D' );
					this.enable( targets.t, targets.c );
				}
			}
		];
	}

	moveRowColumnButtons() {
		const rowbutton = document.querySelector( '#rowBContainer' );
		const columnbutton = document.querySelector( '#columnBContainer' );

		const sceneUnit = this.managers.SceneManager.scene2DUnit;
		const size = sceneUnit.getGridFullSize();

		const rowPos3D = new Vector3( -size.width / 2.0, 0, size.length / 2.0 );
		const columnPos3D = new Vector3( size.width / 2.0 + 10, 0, -size.length / 2.0 - 5 );

		const rowPos2D = sceneUnit.toScreenXY( rowPos3D, sceneUnit.camera, sceneUnit.container );
		const columnPos2D = sceneUnit.toScreenXY( columnPos3D, sceneUnit.camera, sceneUnit.container );

		rowbutton.style.cssText = `
			position: fixed;
			left: ${rowPos2D.x}px;
			top: ${rowPos2D.y}px;
			display: flex;
		`;
		columnbutton.style.cssText = `
			position: fixed;
			left: ${columnPos2D.x}px;
			top: ${columnPos2D.y}px;
			display: flex;
		`;
	}
}